import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule } from '@angular/forms';
import { Enquiryline } from 'src/app/model/enquiryline.model';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Purchaseheader } from 'src/app/model/purchaseheader.model';
import { Purchaseline } from 'src/app/model/purchaseline.model';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from '../../../../environments/environment';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-viewinvoicedetail',
  templateUrl: './viewinvoicedetail.component.html',
  styleUrls: ['./viewinvoicedetail.component.css']
})
export class ViewinvoicedetailComponent implements OnInit {

  orderId: string;
  invoiceData: any;
  purchaseData: any;
  purchaseHeader: Purchaseheader;

  data: any = [];
  grandTotal: number;

  isUserLoggedIn: boolean;
  isUserAdmin: boolean;
  isUserVendor: boolean;
  readonly rootUrl = environment.baseUrl;

  isUserPurchase: boolean;
  isUserFinance: boolean;
  isUserSiteinc: boolean;


  constructor(private router: Router, private route: ActivatedRoute,
    private engineeringServices: EngineeringService, private invoiceServices: InvoiceService,
    private userService: UserService) {
    this.orderId = this.route.snapshot.params.orderid;

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isUserFinance.subscribe(
      value => {
        this.isUserFinance = value;
      });
    this.userService.isUserPurchase.subscribe(
      value => {
        this.isUserPurchase = value;
      }
    );
    this.userService.isUserSiteinc.subscribe(
      value => {
        this.isUserSiteinc = value;
      }
    );
  }

  ngOnInit() {
    this.getOrderById();
  }

  getOrderById() {
    var lineTotal = 0;
    this.grandTotal = 0;
    this.invoiceServices.GetInvoiceById(this.orderId).subscribe(
      datas => {
        console.log(datas);
        this.invoiceData = datas;

        var mydate = new Date(this.invoiceData.invoiceDate);
        //this.invoiceData.invoiceDate = mydate.getFullYear() + '-' + mydate.getMonth() + '-' + mydate.getDay()
        this.invoiceData.invoiceDate = mydate.toDateString();
        // this.purchaseData = datas;
        // this.purchaseHeader = this.purchaseData;
        this.data = this.invoiceData.invoiceLine;
        console.log(this.data);
        for (var i = 0; i < this.data.length; i++) {
          var unicost = this.data[i].unitCost;
          unicost = unicost.replace(/\,/g, '');
          this.data[i].unitCost = unicost;

          var quantty = this.data[i].quantity;
          quantty = quantty.replace(/\,/g, '');
          this.data[i].quantity = quantty;

          lineTotal = parseInt(unicost) * parseInt(quantty);
          this.grandTotal = this.grandTotal + lineTotal;
        }

        //console.log(this.purchaseHeader);
      });
  }

  SubmitTechPriceQuoteForm(form: NgForm) {
    console.log(form.value);
    form.value.id = this.invoiceData.id;

    if(isNullOrUndefined(form.value.approvalPd))
    {
      form.value.approvalPd = this.invoiceData.approvalPd;
    }

    if(isNullOrUndefined(form.value.approvalPm))
    {
      form.value.approvalPm = this.invoiceData.approvalPm;
    }

    if(isNullOrUndefined(form.value.siteApproval))
    {
      form.value.siteApproval = this.invoiceData.siteApproval;
    }

    if(isNullOrUndefined(form.value.grnNo))
    {
      form.value.grnNo = this.invoiceData.grnNo;
    }

    this.invoiceServices.submitInvoiceApproval(form.value).subscribe(
      (data: any) => {
        console.log(data);
        if (data == true) {
          alert("submitted");
        }
      }
    )
  }

}
